const listaErroresFirma = (err: any) => {
  const lista = document.getElementById("lista-errores");
  const fragment = document.createDocumentFragment();
  err?.forEach((item: any) => {
    console.log(item.error);
    const p = document.createElement("p");
    p.textContent = item.error;
    const referenceNode = fragment.firstChild;
    fragment.insertBefore(p, referenceNode);
  });
  lista?.appendChild(fragment);
  return lista;
};

const bytesToSize = (bytes: number) => {
  let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  /**@ts-ignore */
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  /**@ts-ignore */
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

const eliminarRepetidosPorAtributo = (arr: any, atributo: any) => {
  const nuevoArr: any[] = [];
  arr.forEach((elem: any) => {
    if (!nuevoArr.some((item) => item[atributo] === elem[atributo])) {
      nuevoArr.push(elem);
    }
  });
  return nuevoArr;
};

const orderListAsc = (data: any[], param: string) => {
  data.sort((a, b) => {
    if (a[param] < b[param]) {
      return -1;
    }
    return 1;
  });
  return data;
};

const deletePropertiesEmptyObj = (objectDta: any, param: string) => {
  let obj = {};
  Object.keys(objectDta).forEach((key) => {
    if (objectDta[key] !== param) {
      obj = { ...obj, [key]: objectDta[key] };
    }
  });

  return obj;
};

const validateEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export {
  listaErroresFirma,
  bytesToSize,
  eliminarRepetidosPorAtributo,
  orderListAsc,
  deletePropertiesEmptyObj,
  validateEmail,
};
